module.exports = __webpack_public_path__ + "img/IC_Trabajo.11857ebc.svg";